import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import getMainCtas from "../../../middleware/main_ctas";
import AnyDevice from "./any_device";
import EasyToUse from "./easy_to_use";
import Hero from "./hero";
import NativeSpeakers from "./native_speakers";
import Questions from "./questions";
import Save40 from "./save_40";
import StreamDigital from "./stream_digital";
import Teachers from "./teachers";
import TechSupport from "./tech_support";
import CreatorSection from "./creator";
import { useLocation } from "react-router-dom";

const HomePage: React.FC = () => {
  const main_ctas = getMainCtas();
  const { search } = useLocation();
  useEffect(() => {
    if (search.includes("code")) {
      window.location.href = "/signin?code=" + search;
    }
  }, [search]);
  return (
    <div className="home_page landing_page">
      <Helmet title="The Go-to World Language Digital Reader for Students | Flangoo" />
      <Hero main_cta={main_ctas.main} />
      <StreamDigital />
      <NativeSpeakers />
      <Questions />
      <EasyToUse />
      <Teachers />
      <AnyDevice />
      <TechSupport />
      <Save40 />
      <CreatorSection />
      <div className=" text-center py-4">
        <a
          href="https://flangoo-cdn.s3.us-east-2.amazonaws.com/ACTFL+standards+and+Flangoo.docx"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          Download the ACTFL Standards Alignment
          <i className="ml-2 far fa-file-download" aria-hidden="true"></i>
        </a>
        <br />
        <a
          href="https://flangoo-cdn.s3.us-east-2.amazonaws.com/ESSER_Facts_E-Book_v.pdf?v=2"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary mt-2"
        >
          Download the ESSER Grant
          <i className="ml-2 far fa-file-download" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  );
};

export default HomePage;
